<template>
  <div>
    <table-widget :items="files" :perPage="perPage" :totalRows="totalRows" :current-page.sync="currentPage"
      :filter.sync="filter">
      <template slot="buttons">

        <b-form-file v-if="editable" id="supporting-file-input" class="input-group ml-2" placeholder="Choose Files"
          v-model="file" multiple></b-form-file>
        <b-button v-if="editable" :disabled="!file" @click="enterFiles" class="ml-2"
          variant="primary"><font-awesome-icon icon="plus" />Add File(s)</b-button>

      </template>
      <template slot="content">
        <b-alert show><font-awesome-icon icon="exclamation-circle" /> Files are not saved until you click the submit
          button below.</b-alert>
        <b-table striped :items="selectedFiles" :fields="fields" :per-page="perPage" :current-page="currentPage"
          :filter="filter" @filtered="onFiltered" small show-empty :tbody-transition-props="transProps"
          empty-filtered-text="There are no files that match your search criteria.">
          <template v-slot:cell(fileName)="data">
            <template v-if="data.item.fileId">
              <a target="_blank" :href="getFileHref(data.item.fileId)"><font-awesome-icon icon="download" />
                {{ data.item.name }}</a>
            </template>

            <template v-else> {{ data.item.name }} </template>
          </template>
          <template v-slot:cell(createdDate)="data">
            {{ data.item.createdDate | formatDateTime }}
          </template>
        </b-table>
      </template>
    </table-widget>
  </div>
</template>

<script>
import TableWidget from "../table-widget"
import toastr from "toastr"
import ToastrSettings from "../../settings/toastr-settings"
import * as _ from "lodash" // eslint-disable-line no-unused-vars

export default {
  data() {
    return {
      transProps: {
        // Transition name
        name: "fade"
      },
      items: [],
      fields: [
        { key: "fileName", label: "File Name" },
        { key: "createdBy", label: "Uploaded By" },
        { key: "createdDate", label: "Date" }
      ],
      currentPage: 1,
      perPage: 20,
      filter: null,
      totalRows: 0,
      selectedFiles: [],
      file: null,
      maxFiles: 5,
      requestHeaders: { "X-Requested-With": "XMLHttpRequest" }
    }
  },

  props: {
    files: {
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    editable: {
      type: Boolean,
      required: false,
      default: function () {
        return false
      }
    }
  },

  components: { "table-widget": TableWidget },

  computed: {},

  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    enterFiles: function () {
      // add files to file array
      var that = this
      var successfulFiles = []
      _.forEach(that.file, function (file) {
        // only add the file if it is an accepted type and is smaller than 2MB
        var fileTypeAccepted = true // _.includes(that.acceptedFileTypes, file.type);
        if (fileTypeAccepted && file.size < 2000000) {
          //that.selectedFiles.push(file);
          successfulFiles.push(file)
        }
      })
      that.$emit("fileAdded", successfulFiles)
      that.file = null
    },

    removeFile: function (file) {
      // var that = this;
      // this.selectedFiles = _.reject(this.selectedFiles, function(selectedFile) {
      //   that.$emit("fileRemoved", selectedFile);
      //   return file === selectedFile;
      // });
    },

    getFileHref: function (fileId) {
      // console.log("File ID:");
      // console.log(fileId);

      return process.env.VUE_APP_BASE_URI + "/api/files/" + fileId
    }
  },

  watch: {
    files: function () {
      if (this.files.length) {
        this.selectedFiles = this.files
        this.totalRows = this.files.length
      } else {
        this.selectedFiles = this.files
        this.totalRows = 0
      }
    }
  },

  created() {
    if (this.files.length) {
      this.selectedFiles = this.files
      this.totalRows = this.files.length
    }
  }
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}
</style>
